import Client from './client'

export default class Platform {
    constructor() {
        this.client = new Client()
    }

    /**
     * Returns all IDLs available on the platform for the current project/env.
     * Response shape: { components: Record<string, EntityIDL>, functions: Record<string, PlatformFunctionSignature> }
     */
    async idl() {
        return await this.client.http().get('/v1/system/idl')
    }
}
